import { lazy, Suspense } from 'react';
import { CircularProgress } from '@mui/material';

import { Switch, Route, Redirect, useRouteMatch } from 'react-router-dom';
import RoutePrivate from 'components/common/route-private';
import { config } from 'config';

const ShopProducts = lazy(() => import('components/PRODUCT/shop'))
const SeqProducts = lazy(() => import('components/PRODUCT/group'))
const VipProducts = lazy(() => import('components/PRODUCT/vip'))
const Payback = lazy(() => import('components/PRODUCT/payback'))

const Products = () => {
  let { path } = useRouteMatch();

  return (
    <Suspense fallback={<CircularProgress />}>
      <Switch>

        <RoutePrivate exact path={`${path}/shop`} component={ShopProducts} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/group`} component={SeqProducts} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/vip`} component={VipProducts} permission='VIEWER' />
        <RoutePrivate exact path={`${path}/payback`} component={Payback} permission='VIEWER' />

        <Route path='*'>
          <Redirect to={`/${config.game}/dashboard/notfound`} />
        </Route>
      </Switch>
    </Suspense>
  );
};

export default Products;
